import React from 'react'
import styled from 'styled-components'
import { colors, breakpoints } from "../styles"

const width = window.innerWidth > 600 ? 2006 : 1503;
const height = 360;
const s = window.innerWidth > 600 ? 80 : 60;
const noFilters = /iOS/.exec(navigator.userAgent) || (/safari/i.exec(navigator.userAgent) && !(/chrome/i.exec(navigator.userAgent))) || (/Twitter for iPhone/i.exec(navigator.userAgent))

const SVG = styled.svg`
  position: absolute;
  z-index: 0;
  bottom: 0;
  left: calc(50vw - ${width / 2}px);
  width: ${width}px;
  height: ${height}px;
  ${ props => props.fadeIn && `animation: fade-in 1s ${props.theme.animating ? '1s' : '0s'} ease-out both;` }
  
  line,path {
    stroke: ${colors.blueLine};
    stroke-width: 1px;
  }
`

const Horizontal = styled.path`
  shape-rendering: crispEdges;
`

const Vertical = styled.path`
  > line {
    ${breakpoints.nonretina`
      stroke-width: 1.5px;
    `}
  }
`

const C = Math.atan(height / width)
const calculateH = (k) => {
  const B = Math.atan(height / k)
  const A = Math.PI - B - C;
  const h = (0.5 * width * Math.sin(B) * Math.sin(C)) / Math.sin(A)
  return h <= height && h
}

const ks = [...Array(Math.floor(2 * width / s))].map((_, i) => (
  s * (i % 2 === 0 ? (i + 1) / 2 : -i / 2)
))

var hs = ks.map(calculateH).filter(h=>h)
var maxH = Math.max(...hs)
var horizontals = hs.map(h => `M${-width} ${h} L ${width} ${h}`).join(" ");
var verticals = ks.map(k => `M 0 0 L ${k} ${maxH}`).join(" ");
export default ({fadeIn}) => (
  <SVG fadeIn={fadeIn} viewBox={`-${width / 2} 0 ${width} ${height}`}>
    <defs>
      <radialGradient id="Gradient" cx="50%" cy="100%" r="100%">
        <stop offset="20%" stopColor="white"/>
        <stop offset="80%" stopColor="black"/>
      </radialGradient>
      <mask id="Mask">
        <rect x={-width / 2} y="0" width={width} height={height} fill="url(#Gradient)"/>
      </mask>
      <filter id="glow-h">
        <feGaussianBlur stdDeviation="6 0" result="glow"/>
        <feMerge>
          <feMergeNode in="SourceGraphic"/>
          <feMergeNode in="glow"/>
          <feMergeNode in="glow"/>
        </feMerge>
      </filter>
      <filter id="glow-v">
        <feGaussianBlur stdDeviation="0 6" result="glow"/>
        <feMerge>
          <feMergeNode in="SourceGraphic"/>
          <feMergeNode in="glow"/>
          <feMergeNode in="glow"/>
        </feMerge>
      </filter>
    </defs>
    <g mask="url(#Mask)">
      <Horizontal filter={noFilters ? null : "url(#glow-v)"} d={horizontals}/>
      <Vertical filter={noFilters ? null : "url(#glow-h)"} d={verticals}/>
    </g>
  </SVG>
)



/** WEBPACK FOOTER **
 ** ./src/components/SVGGrid.js
 **/